<template>
  <div class="coupon-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="券名称">
          <el-input v-model="filterForm.keyword" placeholder="请输入券名称" clearable style="width: 180px;" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="filterForm.type" placeholder="全部" clearable style="width: 140px;">
            <el-option label="新人专享" :value="1" />
            <el-option label="活动券" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filterForm.display" placeholder="全部" clearable style="width: 120px;">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="platform-tip">
        <i class="el-icon-info"></i>
        <span>券模板为平台级配置（sh_id=1），仅平台管理员可增删改；新人专享券由系统内置，注册自动发放，不可删除、不可手动下发。</span>
      </div>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddDialog">新增活动券</el-button>
      </div>

      <el-table
        v-loading="loading"
        :data="templateList"
        height="56vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="60" align="center" />
        <el-table-column label="券名称" min-width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
            <el-tag v-if="scope.row.code === 'newcomer'" size="mini" type="warning" style="margin-left: 6px;">内置</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="类型" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.type === 1 ? 'warning' : 'success'">{{ scope.row.type_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="amount_text" label="面额" width="100" align="center" />
        <el-table-column label="使用门槛" min-width="130">
          <template slot-scope="scope">
            <span>{{ Number(scope.row.min_amount) > 0 ? scope.row.min_text : '无门槛' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="scope_text" label="适用范围" width="110" align="center" />
        <el-table-column prop="valid_text" label="有效期" min-width="170" show-overflow-tooltip />
        <el-table-column label="每人限领" width="90" align="center">
          <template slot-scope="scope">
            <span>{{ Number(scope.row.per_limit) === 0 ? '不限' : scope.row.per_limit + ' 张' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="总量/剩余" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="Number(scope.row.total_limit) === 0">不限量</span>
            <span v-else>共 {{ scope.row.total_limit }}<br />剩 {{ scope.row.left_count }}</span>
          </template>
        </el-table-column>
        <el-table-column label="发放/核销" width="90" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.sent_count }} / {{ scope.row.used_count }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.display"
              :active-value="1"
              :inactive-value="0"
              @change="handleToggleDisplay(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="60" align="center" />
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="goSend(scope.row)"
              :disabled="!scope.row.can_send"
            >发券</el-button>
            <el-button type="text" size="small" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c;"
              :disabled="scope.row.code === 'newcomer'"
              @click="handleDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogMode === 'add' ? '新增活动券' : '编辑券模板'"
      :visible.sync="dialogVisible"
      width="640px"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-form ref="templateForm" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="券名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入券名称" maxlength="30" show-word-limit />
        </el-form-item>
        <el-form-item label="面额" prop="amount">
          <el-input-number v-model="form.amount" :min="0.01" :step="1" :precision="2" style="width: 200px;" />
          <span style="margin-left: 8px; color: #999;">元</span>
        </el-form-item>
        <el-form-item label="使用门槛" prop="min_amount">
          <el-input-number v-model="form.min_amount" :min="0" :step="5" :precision="2" style="width: 200px;" />
          <span style="margin-left: 8px; color: #999;">元，0 = 无门槛</span>
        </el-form-item>
        <el-form-item label="适用范围" prop="scope">
          <el-radio-group v-model="form.scope" :disabled="isNewcomerEdit">
            <el-radio :label="1">全商城通用</el-radio>
            <el-radio :label="2">指定分类</el-radio>
            <el-radio :label="3">指定商品</el-radio>
          </el-radio-group>
          <div v-if="isNewcomerEdit" style="color: #e6a23c; font-size: 12px; line-height: 1.4;">
            新人专享券的适用范围不可修改
          </div>
        </el-form-item>
        <el-form-item v-if="form.scope !== 1" label="范围ID" prop="scope_ids">
          <el-input v-model="form.scope_ids" :placeholder="form.scope === 2 ? '多个分类ID用英文逗号分隔' : '多个商品ID用英文逗号分隔'" />
        </el-form-item>
        <el-form-item label="有效期类型" prop="valid_type">
          <el-radio-group v-model="form.valid_type">
            <el-radio :label="1">领取后 N 天有效</el-radio>
            <el-radio :label="2">固定起止时间</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.valid_type === 1" label="有效天数" prop="valid_days">
          <el-input-number v-model="form.valid_days" :min="1" :step="1" style="width: 200px;" />
          <span style="margin-left: 8px; color: #999;">天</span>
        </el-form-item>
        <template v-if="form.valid_type === 2">
          <el-form-item label="开始时间" prop="start_time">
            <el-date-picker
              v-model="form.start_time"
              type="datetime"
              placeholder="选择开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 240px;"
            />
          </el-form-item>
          <el-form-item label="结束时间" prop="end_time">
            <el-date-picker
              v-model="form.end_time"
              type="datetime"
              placeholder="选择结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 240px;"
            />
          </el-form-item>
        </template>
        <el-form-item label="每人限领" prop="per_limit">
          <el-input-number v-model="form.per_limit" :min="0" :step="1" style="width: 200px;" />
          <span style="margin-left: 8px; color: #999;">张，0 = 不限</span>
        </el-form-item>
        <el-form-item label="发放总量" prop="total_limit">
          <el-input-number v-model="form.total_limit" :min="0" :step="10" style="width: 200px;" />
          <span style="margin-left: 8px; color: #999;">张，0 = 不限量</span>
        </el-form-item>
        <el-form-item label="状态" prop="display">
          <el-radio-group v-model="form.display">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :step="1" style="width: 200px;" />
          <span style="margin-left: 8px; color: #999;">越小越前</span>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { templateLists, templateAdd, templateEdit, templateDel } from '@/api/coupon'

export default {
  name: 'CouponTemplates',
  data () {
    return {
      loading: false,
      templateList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filterForm: {
        keyword: '',
        type: '',
        display: ''
      },
      // 弹窗
      dialogVisible: false,
      dialogMode: 'add',
      submitting: false,
      form: this.getDefaultForm(),
      rules: {
        name: [{ required: true, message: '请输入券名称', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入券面额', trigger: 'blur' }]
      }
    }
  },
  computed: {
    isNewcomerEdit () {
      return this.dialogMode === 'edit' && this.form.code === 'newcomer'
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    getDefaultForm () {
      return {
        id: null,
        code: '',
        name: '',
        amount: 5,
        min_amount: 0,
        scope: 1,
        scope_ids: '',
        valid_type: 1,
        valid_days: 30,
        start_time: '',
        end_time: '',
        per_limit: 1,
        total_limit: 0,
        display: 1,
        sort: 0,
        remark: ''
      }
    },

    async fetchList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.filterForm.keyword) params.keyword = this.filterForm.keyword
        if (this.filterForm.type !== '' && this.filterForm.type !== null) params.type = this.filterForm.type
        if (this.filterForm.display !== '' && this.filterForm.display !== null) params.display = this.filterForm.display
        const res = await templateLists(params)
        if (res && String(res.code) === '0') {
          this.templateList = (res.data || []).map(item => ({
            ...item,
            display: Number(item.display) === 1 ? 1 : 0,
            type: Number(item.type),
            can_send: !!item.can_send
          }))
          this.total = res.total || 0
        } else {
          this.templateList = []
          this.total = 0
          this.$message.error(res && res.msg ? res.msg : '获取券模板列表失败')
        }
      } catch (error) {
        console.error('获取券模板列表失败', error)
        this.templateList = []
        this.total = 0
        this.$message.error(error.message || '网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.currentPage = 1
      this.fetchList()
    },

    handleReset () {
      this.filterForm = { keyword: '', type: '', display: '' }
      this.currentPage = 1
      this.fetchList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchList()
    },

    goSend (row) {
      if (!row.can_send) return
      this.$router.push({ path: '/coupon/send', query: { tpl: row.id } })
    },

    openAddDialog () {
      this.dialogMode = 'add'
      this.form = this.getDefaultForm()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.templateForm && this.$refs.templateForm.clearValidate()
      })
    },

    openEditDialog (row) {
      this.dialogMode = 'edit'
      this.form = {
        ...this.getDefaultForm(),
        id: row.id,
        code: row.code || '',
        name: row.name || '',
        amount: parseFloat(row.amount) || 0,
        min_amount: parseFloat(row.min_amount) || 0,
        scope: Number(row.scope) || 1,
        scope_ids: row.scope_ids || '',
        valid_type: Number(row.valid_type) || 1,
        valid_days: Number(row.valid_days) || 30,
        start_time: row.start_time || '',
        end_time: row.end_time || '',
        per_limit: Number(row.per_limit) || 0,
        total_limit: Number(row.total_limit) || 0,
        display: Number(row.display) === 1 ? 1 : 0,
        sort: Number(row.sort) || 0,
        remark: row.remark || ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.templateForm && this.$refs.templateForm.clearValidate()
      })
    },

    closeDialog () {
      this.$refs.templateForm && this.$refs.templateForm.resetFields()
    },

    validateForm () {
      if (Number(this.form.amount) <= 0) {
        this.$message.error('券面额必须大于 0')
        return false
      }
      if (Number(this.form.min_amount) < 0) {
        this.$message.error('使用门槛不能为负数')
        return false
      }
      if (this.form.valid_type === 1 && Number(this.form.valid_days) <= 0) {
        this.$message.error('请填写领取后有效天数')
        return false
      }
      if (this.form.valid_type === 2 && (!this.form.start_time || !this.form.end_time)) {
        this.$message.error('固定有效期需要填写开始与结束时间')
        return false
      }
      if (this.form.valid_type === 2 && this.form.end_time <= this.form.start_time) {
        this.$message.error('结束时间必须晚于开始时间')
        return false
      }
      if (this.form.scope !== 1 && !this.form.scope_ids) {
        this.$message.error(this.form.scope === 2 ? '请填写适用分类ID' : '请填写适用商品ID')
        return false
      }
      return true
    },

    async submitForm () {
      try {
        await this.$refs.templateForm.validate()
      } catch (e) {
        return
      }
      if (!this.validateForm()) return

      this.submitting = true
      try {
        let payload
        let res
        if (this.dialogMode === 'add') {
          // 新增只支持活动券；固定有效期才传起止时间，动态有效期只传 valid_days
          payload = { ...this.form }
          delete payload.id
          delete payload.code
          if (payload.scope === 1) payload.scope_ids = ''
          if (payload.valid_type === 1) {
            delete payload.start_time
            delete payload.end_time
          } else {
            delete payload.valid_days
          }
          res = await templateAdd(payload)
        } else {
          payload = { id: this.form.id }
          // 只提交需要变更的字段；新人券后端会忽略 scope/scope_ids
          ;['name', 'amount', 'min_amount', 'scope', 'scope_ids', 'valid_type', 'valid_days', 'start_time', 'end_time', 'per_limit', 'total_limit', 'display', 'sort', 'remark'].forEach(key => {
            payload[key] = this.form[key]
          })
          if (this.form.scope === 1) payload.scope_ids = ''
          if (this.form.valid_type === 1) {
            payload.start_time = ''
            payload.end_time = ''
          } else {
            payload.valid_days = 0
          }
          res = await templateEdit(payload)
        }
        if (res && String(res.code) === '0') {
          this.$message.success(res.message || '操作成功')
          this.dialogVisible = false
          this.fetchList()
        } else {
          this.$message.error(res && res.msg ? res.msg : '操作失败')
        }
      } catch (error) {
        console.error('提交失败', error)
        this.$message.error(error.message || '网络错误，请稍后重试')
      } finally {
        this.submitting = false
      }
    },

    async handleToggleDisplay (row) {
      const newVal = Number(row.display) === 1 ? 1 : 0
      try {
        const res = await templateEdit({ id: row.id, display: newVal })
        if (res && String(res.code) === '0') {
          this.$message.success(newVal === 1 ? '已启用' : '已停用')
        } else {
          row.display = newVal === 1 ? 0 : 1
          this.$message.error(res && res.msg ? res.msg : '状态更新失败')
        }
      } catch (error) {
        row.display = newVal === 1 ? 0 : 1
        console.error('状态更新失败', error)
        this.$message.error(error.message || '网络错误')
      }
    },

    async handleDelete (row) {
      if (row.code === 'newcomer') {
        this.$message.warning('新人专享券是新人礼包的内置模板，不能删除，可改为停用')
        return
      }
      try {
        await this.$confirm(`确定要删除券模板「${row.name}」吗？已发放过的模板将自动改为停用（不删除历史券）。`, '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      try {
        const res = await templateDel({ id: row.id })
        if (res && String(res.code) === '0') {
          this.$message.success(res.message || '删除成功')
          this.fetchList()
        } else {
          this.$message.error(res && res.msg ? res.msg : '删除失败')
        }
      } catch (error) {
        console.error('删除失败', error)
        this.$message.error(error.message || '网络错误')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;
    }
  }

  .platform-tip {
    padding: 8px 12px;
    margin-top: 12px;
    background: #fdf6ec;
    border: 1px solid #faecd8;
    border-radius: 4px;
    color: #e6a23c;
    font-size: 13px;

    i {
      margin-right: 6px;
    }
  }

  .table-card {
    .table-header {
      margin-bottom: 12px;
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
